import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HumanResourcesDashboardComponent } from './human-resources-dashboard/human-resources-dashboard.component';
import { AuthenticationGuard } from '../../../shared/guard/authentication-guard';
import { HeaderMenuType } from '../../../shared/store/view/types';
import { Entity } from '../../../shared/store/view/types';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';

const routes: Routes = [
  {
    path: 'HumanResources',
    data: {
      breadcrumb: { label: ' ', alias: 'humanResourcesDashboard' },
    },
    children: [
      {
        path: '',
        redirectTo: 'Home',
        pathMatch: 'full',
      },
      {
        path: 'Home',
        component: HumanResourcesDashboardComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.HumanResources,
          entity: Entity.HumanResourcesDashboard,
          breadcrumb: { skip: true },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HumanResourcesDashboardRoutingModule {}
